import React from 'react';

// Side-app logo renderer. Two data sources, in priority order:
//
//   1. `logoImageUrl` — CDN asset (raster or SVG) from the side-app's
//      Ruby-side `branding` hash (`logo_image_url`). Preferred for new apps.
//   2. `logoKey` — inline SVG registered in SIDE_APP_LOGOS below, keyed by
//      `logo_inline_svg_key`. Legacy path for in-code marks.
//
// SideAppFullLogo handles the full horizontal brand mark (`logo_full_svg_key`);
// when present, it's rendered standalone without "powered by TezLab".
const SIDE_APP_LOGOS = {};

// Full horizontal brand marks — keyed by `logo_full_svg_key`. When a
// side-app provides one, it's rendered standalone at the top of the SSO
// flow (no "powered by TezLab" attribution beneath it).
// eslint-disable-next-line no-unused-vars
const SIDE_APP_FULL_LOGOS = {};

export function SideAppFullLogo(props) {
  const Logo = props.fullLogoKey && SIDE_APP_FULL_LOGOS[props.fullLogoKey];
  if (!Logo) return null;
  return <Logo />;
}

export default function SideAppLogo(props) {
  if (props.logoImageUrl) {
    return <img src={props.logoImageUrl} alt={props.alt || ''} width="72" height="72" />;
  }
  const Logo = props.logoKey && SIDE_APP_LOGOS[props.logoKey];
  if (!Logo) return null;
  return <Logo />;
}
